Ext.define('SA.view.color.SlideBar', {
    alias: 'widget.color-window-slide-bar',
    extend: 'Ext.Component',

    cls: 'sa-color-window-slider-bar x-unselectable',

    html: (function() {
        var repeater = [];

        repeater[64] = '<div class="sa-color-window-slider-arrow"></div>';

        return repeater.join('<span class="sa-color-window-slider-slice"></span>');
    })(),

    initEvents() {
        this.callParent();

        this.el.on('mousedown', this.onMouseDown, this);
    },

    onMouseDown(ev) {
        var doc = Ext.getDoc();

        this.onSlide(ev);

        this.mon(doc, 'mousemove', this.onSlide, this);

        this.mon(doc, 'mouseup', () => {
            this.mun(doc, 'mousemove', this.onSlide, this);
        }, this, {single: true});
    },

    onSlide(ev) {
        var el = this.el,
            x = ev.getX() - el.getX(),
            proportion = Ext.Number.constrain((x - el.getFrameWidth('l') - 1) / (el.getWidth(true) - 1), 0 , 1);

        this.updateArrow(proportion);

        this.fireEvent('slide', this, proportion * this.maxValue);

        ev.preventDefault();
    },

    setColor(color) {
        var component = this.component,
            value = color.get(component) || 0,
            max = this.maxValue,
            scaleMax = max,
            slices = this.el.dom.children,
            sliceCount = slices.length - 1, 
            slice = slices[0],
            oldColor = this.color;

        this.color = color;

        if (/s|l/.test(component)) {
            value *= 100;
            max = 1;
        }
        else if (component === 'h') {
            max = 360 * (sliceCount - 1) / sliceCount;
        }

        this.updateArrow(value / scaleMax);

        if (oldColor && oldColor.derive(component, max / 2).getColor() === color.derive(component, max / 2).getColor()) {
            return;
        }

        for (var i = 0 ; i < sliceCount ; ++i) {
            Ext.fly(slice).setStyle('background-color', '#' + color.derive(component, max * i / (sliceCount - 1)).getColor());

            slice = slice.nextSibling;
        }
    },

    updateArrow(proportion) {
        var el = this.el,
            innerElWidth = this.innerElWidth || (this.innerElWidth = el.getWidth(true)),
            arrow = this.arrow || (this.arrow = el.down('.sa-color-window-slider-arrow'));

        arrow.setStyle('left', innerElWidth * proportion - 4 + 'px');
    }
});